import React from "react";
import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png'

const Corporate_Inquiry_Report = ({ data }) => {
  Font.register({
    family: 'Poppins',
    fonts: [
      {
        src: '/fonts/Poppins-Regular.ttf',
        fontWeight: 'normal',
      },
      {
        src: '/fonts/Poppins-SemiBold.ttf',
        fontWeight: 600,
      },
      {
        src: '/fonts/Poppins-Bold.ttf',
        fontWeight: 'bold',
      },
    ],
  });


  function formatDate(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');        // dd
    const month = String(date.getMonth() + 1).padStart(2, '0'); // mm (months are 0-indexed)
    const year = date.getFullYear();                            // yyyy

    return `${day}-${month}-${year}`;
  }




  const studentList = Array.isArray(data) ? data : [];



  return (
    <Document>
      <Page size="A4" style={{ padding: 30, fontSize: 10 }}>
        {/* Logo View */}
        <View style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <Image src={sitlogo} style={{ width: 90 }} />
        </View>
        {/* Title View */}
        <View
          style={{
            width: "100%",
            padding: 5,
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: 12,
            borderWidth: 1.5,
            borderColor: "black",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text style={{ fontSize: 9 }}>CORPORATE INQUIRY REPORT</Text>
        </View>
        {/* Content View */}
        <View
          style={{
            width: "100%",
            height: "90%",
            borderRight: "1.5px solid black",
            borderLeft: "1.5px solid black",
            borderBottom: "1.5px solid black",
            borderTop: "none",
          }}
        >
          {studentList.map((item, index) => (
            <View
              style={{
                width: '100%',
                height: '15%',
                borderBottom: '1.5px solid black',
                flexDirection: 'row'
              }}
            >
              {/* Left panel */}
              <View
                style={{
                  width: '55%',
                  borderRight: '1.5px solid black',
                  height: '100%',
                  flexDirection: 'column',
                  paddingTop: 3,
                  paddingBottom: 3
                }}
              >

                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Training Programme
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '2%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.Course_Name}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Name
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.FullName}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Company Name
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.CompanyName}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Designation
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.Designation}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Place
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.Place}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Business
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {item.business}
                    </Text>
                  </View>
                </View>
                <View
                  style={{ width: '100%', height: '14%', flexDirection: 'row' }}
                >
                  <View
                    style={{
                      width: '40%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8,
                        paddingLeft: 6
                      }}
                    >
                      Date
                    </Text>
                  </View>
                  <View style={{ width: '2%', height: '100%', justifyContent: 'center' }}>
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      :
                    </Text>
                  </View>
                  <View
                    style={{
                      width: '58%',
                      height: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: 8
                      }}
                    >
                      {formatDate(item.Idate)}
                    </Text>
                  </View>
                </View>

              </View>

              {/* Right panel */}
              <View style={{ width: '45%', height: '100%', paddingTop: 3, paddingBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: 8,
                    paddingLeft: 4
                  }}
                >
                  Discussion   :
                </Text>
                <Text
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontSize: 8,
                    paddingLeft: 8
                  }}
                >
                  {item.Remark}
                </Text>
              </View>
            </View>
          ))}

        </View>
      </Page>
    </Document>
  )
}

export default Corporate_Inquiry_Report